<div class="permission__toggle--container">
    <div class="permission__toggle--details">
        <h5>{{permissionHeading}}</h5>
        <span>{{permissionDesc}}</span>
    </div>
    <div class="permission__toggle--btn">
        <acengage-toggle-switch></acengage-toggle-switch>
    </div>
</div>